function SubscriptionNotification(info) {
    this.info = info;
}

module.exports = SubscriptionNotification;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/subscription-notification/subscription-notification.js
// module id = 320
// module chunks = 0